import { slice } from "./reducer";
import * as selectors from "./selector";

export type AppOrigin = "admin" | "gnt" | "unknown";

export interface AppContextState {
  origin: AppOrigin;
}

export const AppContextStore = {
  reducer: slice.reducer,
  actions: slice.actions,
  selectors,
};
